<template>
  <NuxtLink :to="`${vacancyBaseUrl}/${vacancy.slug}`" class="text-decoration-none">
    <v-card
        class="h-100 d-flex flex-column pa-0"
        variant="text"

      >

            <!-- RIJ 1: CHIPS -->
            <div class="pa-4 chipsdiv" style="height: 88px">
                <div class="d-flex flex-wrap justify-end">
                    <v-chip
                        size="small"
                        class="mr-1 mb-1 px-3 py-1"
                    >
                        {{ vacancy.jobCategory?.name }}
                    </v-chip>

                    <v-chip
                        size="small"
                        class="mr-1 mb-1 px-3 py-1"
                    >
                        {{ vacancy.location?.city }}
                    </v-chip>

                    <v-chip
                        size="small"
                        class="mr-1 mb-1 px-3 py-1"
                    >
                        {{
                            vacancy.employmentType === 'permanent'
                                ? $t('vacancies.card.permanent', 'Vast contract')
                                : $t('vacancies.card.temporary', 'Tijdelijk')
                        }}
                    </v-chip>
                </div>
            </div>

            <!-- RIJ 2: TITEL -->
            <v-card-title class="px-4 card-title-wrap">
                {{ vacancy.title }}
            </v-card-title>



            <!-- BESCHRIJVING -->
            <v-sheet
                class="d-flex flex-column flex-grow-1"
                style="min-height:0;"
            >
                <v-card-text class="px-4">
                    <v-card variant="text">
                        <p
                            v-if="vacancy.description"
                            class="pb-0 mb-0 text-body-2 overflow-y-hidden gradient-text"
                            v-html="truncatedDescription"
                        ></p>
                    </v-card>
                </v-card-text>

                <v-card-actions class="pb-5 px-4 mt-auto">
                    <v-btn
                        class="text-decoration-none text-none px-5"
                        variant="text"
                        color="primary"
                    >
                        {{ $t('vacancies.viewDetails', 'Bekijk details') }}
                    </v-btn>
                </v-card-actions>
            </v-sheet>


    </v-card>
  </NuxtLink>
</template>


<script setup>
import { ref, computed } from 'vue'
const { t } = useI18n()
const { $methods, $helpers} = useNuxtApp()
const dataAll = useDataAll()
const vacancyBaseUrl = $methods.pageUrlByPageType('DV') === '/' ? '/vacancy' : $methods.pageUrlByPageType('DV')

const props = defineProps({
  vacancy: {
    type: Object,
    default: () => ({})
  }
})

const vacancyImageSrc = ref(
  props.vacancy.bannerImage ||
  dataAll.getKey('siteSettings.vacancyDefaultImage') ||
  'https://projectcor.com/wp-content/uploads/2022/08/Imagenredondeada_202007-21.png'
)

const truncatedDescription = computed(() => {
  return  $helpers.stripHtml(props.vacancy.description, 150)

})
</script>

<style scoped>
.card-title-wrap {
  white-space: normal;
  word-break: break-word;
}

.image-container {
  position: relative;
}

.chips-overlay {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
}

.gradient-text {
  max-height: 4.5em;
  overflow: hidden;
  position: relative;
}

.gradient-text::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2em;
  background: linear-gradient(transparent, white);
}
</style>
